export enum InsightUrl {
    INSIGHT_URL = "https://api.pearch.se/insight"
}